// import React, { useContext, useEffect, useState } from "react";
// import { NavLink, useNavigate } from "react-router-dom";
// import Axios from "axios";
// import BlogCard from "../Cards/BlogCard";
// import { UserContext } from "../../context/UserContext";

// import Spinner from "../Spinner";

// const BlogField = () => {

//   const [isLoading, setLoading] = useState(true);

//   const { state } = useContext(UserContext);
//   const navigate = useNavigate();

//   const initialValue = {
//     user: "",
//     name: "",
//     createdAt: "",
//     title: "",
//     description: "",
//     profilepic: "",
//     image: ""
//   };

//   const [articles, setArticles] = useState(initialValue);

//   const [like, setLike] = useState(0);

//   const blogFieldFn = async () => {
//     try {
//       const res = await Axios.get("https://blogappserver-8sw1.onrender.com/articles");
//       const data = await res.data;
//       setArticles(data);
//     } catch (error) {
//     }
//   };


//   useEffect(() => {
//     blogFieldFn();

// // Simulating data loading delay
//      const timer = setTimeout(() => {
//       setLoading(false);
//     }, 2000);
  
//     return () => clearTimeout(timer);
//   }, []);

//   return (
//     <>
//     { isLoading ? (
//       <Spinner />
//     ) : (
//       Object.values(articles).map((article) => {
//         return (
//           <span>
//             <div className="blog-field card">
//               {/* Blog Fields */}
//               <BlogCard
//                 id={article._id}
//                 userId = {article.user?._id}
//                 profilePic={article.user?.profilepic}
//                 name={article.user?.name}
//                 createdAt={article.createdAt}
//                 title={article.title}
//                 description={article.description}
//                 blogImage={article.image}
//               />

//               <div className="text-muted text-center my-1">
//                 {/*like and comment functionality*/}
//                 {state ? (
//                   article.likes?.includes(state._id) ? (
//                     // (article.likes?.includes('63c92ac522d471f4d2e81ce7'))
//                     <i
//                       className="fa fa-heart px-5 i-color"
//                       style={{fontSize: "18px"}}
//                       onClick={() => unlikeArticleFn(`${article._id}`)}
//                     >
//                       {article.likes?.length}
//                     </i>
//                   ) : (
//                     <i
//                       className="fa fa-heart-o px-5"
//                       style={{fontSize: "18px"}}
//                       onClick={() => likeArticleFn(`${article._id}`)}
//                     >
//                       {article.likes?.length}
//                     </i>
//                   )
//                 ) : (
//                   <i
//                     className="fa fa-heart-o px-5"
//                     style={{fontSize: "18px"}}
//                     onClick={() => navigate('/login')}
//                   >
//                     {article.likes?.length}
//                   </i>
//                 )}
//                 <NavLink to={`../../articles/${article._id}`}>
//                   <i className="fa fa-comments-o px-5 m-link"
//                     style={{fontSize: "18px"}}

//                   >
//                     {article.messages?.length}
//                   </i>
//                 </NavLink>
//               </div>
//             </div>
//           </span>
//         );
//       }) 
//       )
//     }
//     </>
//   );
// };

// export default BlogField;

import React, { useContext, useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Axios from "axios";
import BlogCard from "../Cards/BlogCard";
import { UserContext } from "../../context/UserContext";

import Spinner from "../Spinner";

const BlogField = () => {
  const [isLoading, setLoading] = useState(true);

  const { state } = useContext(UserContext);
  const navigate = useNavigate();

  const initialValue = {
    user: "",
    name: "",
    createdAt: "",
    title: "",
    description: "",
    profilepic: "",
    image: ""
  };

  const [articles, setArticles] = useState([initialValue]);
  const [like, setLike] = useState(0);

  const blogFieldFn = async () => {
    try {
      const res = await Axios.get("https://blogappserver-8sw1.onrender.com/articles");
      const data = await res.data;
      setArticles(data);
      setLoading(false); // Set loading to false after data is fetched
    } catch (error) {
      setLoading(false); // Set loading to false in case of an error
    }
  };

  
  // /------- like and unlike functionality -------------------------------
  const likeArticleFn = async (id) => {
    try {
      return await Axios.put("https://blogappserver-8sw1.onrender.com/articles/like", { likeId: id }, {
        withCredentials: true
      })
        .then((res) => res.data)
        .then((result) => {
          const newData = articles.map((item) => {
            if (item._id === result._id) {
              setLike(like + 1);
              return result;
            } else {
              setLike(like + 1);
              return item;
            }
          });
          setArticles(newData);
        })
        .catch((err) => {
          navigate("/login");
        });
    } catch (e) {
    }
  };

  const unlikeArticleFn = async (id) => {
    try {
      return await Axios.put("https://blogappserver-8sw1.onrender.com/articles/unlike", { likeId: id }, {
        withCredentials: true
      })
        .then((res) => res.data)
        .then((result) => {
          const newData = articles.map((item) => {
            if (item._id === result._id) {
              setLike(like - 1);
              return result;
            } else {
              setLike(like - 1);
              return item;
            }
          });
          setArticles(newData);
        })
        .catch((err) => {
          navigate("/login");
        });
    } catch (e) {
    }
  };

  useEffect(() => {
    blogFieldFn();
  }, []);

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        articles.map((article) => (
          <span key={article._id}>
            <div className="blog-field card">
              {/* Blog Fields */}
              <BlogCard
                id={article._id}
                userId={article.user?._id}
                profilePic={article.user?.profilepic}
                name={article.user?.name}
                createdAt={article.createdAt}
                title={article.title}
                description={article.description}
                blogImage={article.image}
              />

              <div className="text-muted text-center my-1">
                {/* like and comment functionality */}
                {state ? (
                  article.likes?.includes(state._id) ? (
                    <i
                      className="fa fa-heart px-5 i-color"
                      style={{ fontSize: "18px" }}
                      onClick={() => unlikeArticleFn(`${article._id}`)}
                    >
                      {article.likes?.length}
                    </i>
                  ) : (
                    <i
                      className="fa fa-heart-o px-5"
                      style={{ fontSize: "18px" }}
                      onClick={() => likeArticleFn(`${article._id}`)}
                    >
                      {article.likes?.length}
                    </i>
                  )
                ) : (
                  <i
                    className="fa fa-heart-o px-5"
                    style={{ fontSize: "18px" }}
                    onClick={() => navigate('/login')}
                  >
                    {article.likes?.length}
                  </i>
                )}
                <NavLink to={`../../articles/${article._id}`}>
                  <i className="fa fa-comments-o px-5 m-link" style={{ fontSize: "18px" }}>
                    {article.messages?.length}
                  </i>
                </NavLink>
              </div>
            </div>
          </span>
        ))
      )}
    </>
  );
};

export default BlogField;

